/* eslint-disable no-use-before-define */
import React from 'react'
import { arrayToggle, Fields, CORP_SECTORS as SECTORS, publish, subscribe, unsubscribe, isEmpty } from '../../../twd/twd'
import useMarketNews from '../use-market-news'

export default ({isModal, className, id}) => {
    const {
        customIndustry: selected,
        setCustomIndustry: setSelected
    } = useMarketNews()

    const [text, setText] = React.useState('')
    const [searchResults, setSearchResults] = React.useState(SECTORS)
    const [sectorError, setSectorError] = React.useState()

    React.useEffect(() => {
        let a = getSectors({text, selected})
        setSearchResults(a)
    }, [text, selected])

    React.useEffect(() => {
        let subId = subscribe('corporates-market-news-custom-search-changed', (field, keyword) => {
            if (field!=='custom' || isEmpty(keyword)) return
            setSelected([])
        })
        return () => unsubscribe(subId)
    }, [])

    const n = selected.length
    const isAll = n===SECTORS.length
        || n===0

    return <div
        className={ [
                'form-group',
                className,
                (sectorError ? ' has-error ' : '')
            ].join(' ')}
        style={{marginBottom:0}}
    >
    <label>Industry</label>
    <Fields.Search
        id={id}
        dataName="corporates-market-news-custom-search-industry"
        placeholder={ isAll ? 'All' : 'Selected' }
        type="select"
        listConfig={{
            style: { minWidth:'200px' }
        }}
        onSelect={(a) => {
            let arr = arrayToggle(selected, (b) => isEq(a,b), a)
            setSelected([...arr])

            let err = arr.length<5 ? '' : 'Please select up to 4 industries.'
            setSectorError(err)

            if (!err) publish('corporates-market-news-custom-search-changed', 'sector')
        }}
    >
    {({keyword : text}) => {
        setText(text)

        return <React.Fragment><div>{
            searchResults.map((a,i) => (
                <Fields.SearchOption
                    dataName="corporates-market-news-custom-search-industry"
                    item={a}
                    key={i}>
                <Fields.CheckboxLabel
                    dataName="corporates-market-news-custom-search-industry"
                    checked={a.selected}
                    label={a.label} />
                </Fields.SearchOption>)
            )
        }</div></React.Fragment>

    }}
    </Fields.Search>
    <label className="field-status">{sectorError}</label>
    </div>
}

export const getSectors = ({text='', selected=[]} = {}) => {
    let t = text.toLowerCase()
    return SECTORS
        .filter(a => a.sic_code)
        .map(a => Object.assign({...a}, {
            selected: !!selected.find((b) => isEq(a,b))
        }))
        .filter(a => !text
            || a.label.toLowerCase().indexOf(t) >= 0)
}

const isEq = (a, b) => a.label === b.label


// WEBPACK FOOTER //
// ./src/corporates/market-news/custom-search/search-sector.js